import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';
import avaLogo from '../assets/imgs/ava-avatar.png';
import { API_BASE_URL } from '../config';

// const API_BASE_URL = 'http://localhost:3001';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      console.error('Login error:', err);
      const message = err.message || 'Invalid email or password';
      toast.error(message);
      setError(message); // optional: keep if you also want inline display

    } finally {
      setIsLoading(false);
    }
  };

  const handleMicrosoftLogin = () => {
    // Redirect to Microsoft OAuth endpoint
    window.location.href = `${API_BASE_URL}/auth/microsoft`;
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="login-overlay"></div>
      </div>

      <div className="login-content">
        <div className="login-box">
          <div className="login-header">
            <div className="logo-large">
              <img src={avaLogo} alt="AHV Logo" className="logo-image" />
            </div>
            <h1>Cow Treatment Digitizer</h1>
            <p className="subtitle">Enterprise Edition</p>
          </div>

          {error && (
            <div className="login-error">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your.email@ahv.com"
                required
                disabled={isLoading}
                autoFocus
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                disabled={isLoading}
              />
            </div>

            <button
              type="submit"
              className="btn-login"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-small"></span>
                  Signing In...
                </>
              ) : (
                'Sign In'
              )}
            </button>
          </form>

          <div className="divider">
            <span>OR</span>
          </div>

          <button
            type="button"
            className="btn-microsoft"
            onClick={handleMicrosoftLogin}
            disabled={isLoading}
          >
            <svg className="microsoft-icon" viewBox="0 0 23 23">
              <path fill="#f3f3f3" d="M0 0h23v23H0z"/>
              <path fill="#f35325" d="M1 1h10v10H1z"/>
              <path fill="#81bc06" d="M12 1h10v10H12z"/>
              <path fill="#05a6f0" d="M1 12h10v10H1z"/>
              <path fill="#ffba08" d="M12 12h10v10H12z"/>
            </svg>
            Sign in with Microsoft
          </button>

          <div className="login-footer">
		{/*
            <p className="default-credentials">
              <strong>Default Admin Login:</strong><br />
              Email: admin@ahv.com<br />
              Password: Admin@123
            </p>
		*/}
            <p className="app-version">v1.0.0 Enterprise</p>
          </div>
        </div>

        <div className="login-info">
          <h2>Welcome to AHV Treatment Digitizer</h2>
          {/* <ul>
            <li>✓ AI-Powered OCR Pipeline </li>
            <li>✓ Multi-Farm Management</li>
            <li>✓ Secure Authentication</li>
            <li>✓ Role-Based Access Control</li>
            <li>✓ Complete Treatment History</li>
          </ul>*/}
        </div>
      </div>
    </div>
  );
}

export default Login;
